// extracted by mini-css-extract-plugin
export default {"svg":"orders__svg__tUVazq","muted":"orders__muted__HFceoy","secondary":"orders__secondary__HSa5kx"};